/**
 * Shared logic for FundedProjects and ActiveProjects - choose `simplePagination` and `max` props to be passed to
 * Pagination based on project-count.
 *
 * @param forceSimple
 * @param numFundedProposals
 * @returns {{simplePagination, max: *}}
 */
export const choosePaginationProps = (forceSimple, projectCount) => {
    const simplePagination = forceSimple;
    const max = forceSimple ? undefined : projectCount;

    return { simplePagination, max };
};
